import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementSpringCreateMutation, useMeasurementSpringDeleteMutation, useMeasurementSpringFindAllQuery, useMeasurementSpringUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";


const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementSpringFindAllQuery(`?spring_id=${id}`);
  const [measurementSpringCreate, measurementSpringCreateResult] = useMeasurementSpringCreateMutation();
  const [measurementSpringUpdate, measurementSpringUpdateResult] = useMeasurementSpringUpdateMutation();
  const [measurementSpringDelete, measurementSpringDeleteResult] = useMeasurementSpringDeleteMutation();

  const [measurementSpring, setMeasurementSpring] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: commonSpring,
    error: commonSpringError,
    isFetching: isCommonSpringFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_sprint_mode`);

  useEffect(() => {

    if (measurementSpring === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.length);
    const tempContains_water = measurementSpring !== null ? measurementSpring?.contains_water : false;
    const tempIs_clean = measurementSpring !== null ? measurementSpring?.is_clean : false;
    setContains_waterBoolean(tempContains_water)
    setIs_cleanBoolean(tempIs_clean)
  }, [measurementSpring, commonSpring, id, data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementSpring?.id,
      spring_id: measurementSpring?.spring_id,
      spring_code: measurementSpring?.spring_code,
      measure_date: measurementSpring?.measure_date,
      depth: measurementSpring?.depth,
      spurt: measurementSpring?.spurt,
      variation: measurementSpring?.variation,
      cmd_sprint_mode: measurementSpring?.cmd_sprint_mode,
      is_used: measurementSpring?.is_used,

      usage_information: measurementSpring?.usage_information,
      sanitary_requirements: measurementSpring?.sanitary_requirements,
      water_physical_quality: measurementSpring?.water_physical_quality,
      rocks_name: measurementSpring?.rocks_name,
      rocks_index_geologicalage: measurementSpring?.rocks_index_geologicalage,
      report_autor: measurementSpring?.report_autor,
      report_name: measurementSpring?.report_name,
      report_code: measurementSpring?.report_code,

    },
    validationSchema: Yup.object({
      spring_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      spurt: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      variation: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmd_sprint_mode: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_physical_quality: Yup.string().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_index_geologicalage: Yup.number().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      is_used: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (measurementSpring !== null) {
        const updateList = {
          id: measurementSpring?.id,
          spring_id: measurementSpring?.spring_id,
          spring_code: values?.spring_code,
          measure_date: values?.measure_date,
          depth: values?.depth,
          spurt: values?.spurt,
          is_used: values?.is_used,

          variation: values?.variation,
          cmd_sprint_mode: values?.cmd_sprint_mode,
          usage_information: values?.usage_information,
          sanitary_requirements: values?.sanitary_requirements,
          water_physical_quality: values?.water_physical_quality,
          rocks_name: values?.rocks_name,
          rocks_index_geologicalage: values?.rocks_index_geologicalage,
          report_autor: values?.report_autor,
          report_name: values?.report_name,
          report_code: values?.report_code,
          contains_water: contains_water === undefined ? false : contains_water,
          is_clean: is_clean === undefined ? false : is_clean,
        }

        measurementSpringUpdate(updateList);
      } else {
        const newList = {
          spring_id: id,
          spring_code: values["spring_code"],
          measure_date: values["measure_date"],
          depth: values["depth"],
          spurt: values["spurt"],
          variation: values["variation"],
          cmd_sprint_mode: values["cmd_sprint_mode"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          water_physical_quality: values["water_physical_quality"],
          rocks_name: values["rocks_name"],
          rocks_index_geologicalage: values["rocks_index_geologicalage"],
          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
          is_used: values["is_used"],

          contains_water: contains_water === undefined ? false : contains_water,
          is_clean: is_clean === undefined ? false : is_clean,
        };

        measurementSpringCreate(newList)
      }
      validation.resetForm();
    },
  });
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (measurementSpring) {
      measurementSpringDelete(measurementSpring.id);
      setDeleteModal(false);
    }
    setMeasurementSpring(null);
    setIs_newCreated(true)
  };

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementSpring(null);
                setIs_cleanBoolean(false);
                setContains_waterBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>
            {
              is_newCreated === false && measurementSpring !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }

          </div>

        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementSpring?.spring_code}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementSpring(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="spring_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.spring_code || ""}
                        invalid={
                          validation.touched.spring_code &&
                            validation.errors.spring_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.spring_code &&
                        validation.errors.spring_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.spring_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Булгийн ундарга, л/с </Label>
                      <Input
                        name="spurt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.spurt || ""}
                        invalid={
                          validation.touched.spurt &&
                            validation.errors.spurt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.spurt &&
                        validation.errors.spurt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.spurt}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх  </Label>
                      <Input
                        name="is_used"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.is_used || ""}
                        invalid={
                          validation.touched.is_used &&
                            validation.errors.is_used
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        <option value="null">Мэдэхгүй</option>
                        <option value="true">Ашиглаж байгаа</option>
                        <option value="false">Ашиглаагүй</option>

                      </Input>
                      {validation.touched.is_used &&
                        validation.errors.is_used ? (
                        <FormFeedback type="invalid">
                          {validation.errors.is_used}
                        </FormFeedback>
                      ) : null}
                    </div>


                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик чанар </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />

                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ундаргын хэлбэлзэл, л/с </Label>
                      <Input
                        name="variation"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.variation || ""}
                        invalid={
                          validation.touched.variation &&
                            validation.errors.variation
                            ? true
                            : false
                        }
                      />
                      {validation.touched.variation &&
                        validation.errors.variation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.variation}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> хэрэглээний  чиглэл,  түүний  ашиглаптын  (хэрэглээний)  талаарх мэдээлэл </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>

                    {/* <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт, хамгаалалтын талаарх мэдээлэл   </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div> */}
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />

                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Булгийн гүн /м/  </Label>
                      <Input
                        name="depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.depth || ""}
                        invalid={
                          validation.touched.depth &&
                            validation.errors.depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.depth &&
                        validation.errors.depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Булгийн горим </Label>
                      <Input
                        name="cmd_sprint_mode"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmd_sprint_mode || ""}
                        invalid={
                          validation.touched.cmd_sprint_mode &&
                            validation.errors.cmd_sprint_mode
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>

                        {commonSpring?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}

                      </Input>
                      {validation.touched.cmd_sprint_mode &&
                        validation.errors.cmd_sprint_mode ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmd_sprint_mode}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр, эрүүл ахуйн шаардлага хангалт </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус агуулагч чулуулгийн нэр  </Label>
                      <Input
                        name="rocks_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.rocks_name || ""}
                        invalid={
                          validation.touched.rocks_name &&
                            validation.errors.rocks_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.rocks_name &&
                        validation.errors.rocks_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.rocks_name}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Чулуулгийн геологийн насны индекс </Label>
                      <Input
                        name="rocks_index_geologicalage"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.rocks_index_geologicalage || ""}
                        invalid={
                          validation.touched.rocks_index_geologicalage &&
                            validation.errors.rocks_index_geologicalage
                            ? true
                            : false
                        }
                      />
                      {validation.touched.rocks_index_geologicalage &&
                        validation.errors.rocks_index_geologicalage ? (
                        <FormFeedback type="invalid">
                          {validation.errors.rocks_index_geologicalage}
                        </FormFeedback>
                      ) : null}
                    </div>



                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар 	 </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>


                  </Col>
                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>

    </>
  )
}

export default Measurement;